// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { RootAction, actionCreatorsList } from '../rootActionCreator';

export interface updateReadSupportPageState {
  read: boolean;
  isLoading: boolean;
  isListFetching: boolean;
  error?: Error;
}

const {
  updateReadSupportActions,
} = actionCreatorsList;

export const initialState: updateReadSupportPageState = {
  read: false,
  isLoading: true,
  isListFetching: true,
};

const readSupportReducer = (state = initialState, action: RootAction): updateReadSupportPageState => {
  switch (action.type) {
    case getType(updateReadSupportActions.request): {
      return {
        ...state,
        isLoading: true,
        error: undefined
      };
    }
    case getType(updateReadSupportActions.success): {
      const { read } = action.payload
      return {
        ...state,
        isLoading: false,
        read
      };
    }
    case getType(updateReadSupportActions.failure): {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
}

export { readSupportReducer as default };
